<template>
  <v-container class="pa-0">
    <div style="display:grid; gap: 24px">
      <div class="mt-24px" >
        <v-btn
        v-if="getMenuItemVisible('edit_najomca')"
        class="btn-secondary"
        @click="redirectToEditNajomca(pripad.newId, true)"
        :disabled="!getMenuItemEnabled('edit_najomca')"
        >Pridať novú kontaktnú osobu</v-btn
      >
      <v-btn
        class="btn-secondary ml-16px"
        @click="redirectToUploadDokumentov(pripad.newId, '0', '', 'sumar-zadatel')"
        :disabled="pripad == null || pripad.newId == null"
      >
        Dokumenty
      </v-btn>
  
      <v-tooltip top :close-delay="0" :open-delay="200">
        <template v-slot:activator="{ on }">
          <v-btn
            v-if="getMenuItemVisible('edit_najomca')"
            class="btn-secondary right btn-icon"
            v-on="on"
            :disabled="!getMenuItemEnabled('edit_najomca')"
            @click="redirectToEditNajomca(pripad.newId)"
            ><v-icon>mdi-pencil-outline</v-icon></v-btn
          >
        </template>
        <span>Editovať</span>
      </v-tooltip>
      <!-- <v-btn @click="openPdfDialog()">open dialog</v-btn> -->
    </div>

      <!-- SUMAR START -->
    
    <v-card v-if="pravoNaAdresnuPonuku && (suhlasyNajomcovia.length > 0 || showSuhlasySensitiveBusiness) && jeDealer" class="card">
      <v-expansion-panels class="wizard-expansion-panels" flat v-model="panel">
        <v-expansion-panel>
          <v-expansion-panel-header class="pa-0">
            <h2>Súhlasy</h2>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <!-- <v-col v-for="k in 4" :key="k">
                <v-card class="pa-2" outlined tile> {{ k }} of {{ 4 }} </v-card>
              </v-col> -->

            <v-form
              v-for="(sn, index) in suhlasyNajomcovia"
              v-bind:key="index"
              style="
                border: 1px solid #2c2e34;
                max-width: 100%;
                text-align: left;
                border-radius: 12px;
              "
              class="mt-20px"
              :ref="'form_suhlasy' + sn.suhlasy[0].id_zastupcu"
              v-model="sn.formSuhlasyValid"
              autocomplete="off"
            >
              <v-row no-gutters>
                <v-col cols="12" class="pa-16px">
                  <h3 v-if="sn.suhlasy !== undefined">
                    {{ sn.suhlasy && sn.suhlasy.length ? sn.suhlasy[0].meno : '' }}
                  </h3>
                  
                </v-col>
                <v-col cols="12" >
                  <v-divider ></v-divider>
                </v-col>
                
                <v-col cols="12" class="pa-16px pb-0" v-for="(item, index) in sn.suhlasy" v-bind:key="index" >
                  <v-row no-gutters>
                    <v-col cols="auto">
                      <v-checkbox
                        style="white-space: normal; margin-top: 0px"
                        v-bind:class="{
                          dynamic_check_box: true,
                          required: item.is_required,
                          successful: getSuhlasSuccess(sn,item)
                        }"
                        class="checkbox-suhlas"
                        :readonly="getSuhlasReadonly(getSuhlas(sn,item),item)"
                        :disabled="!item.is_enabled"
                        :rules="item.is_required ? requiredRule : []"
                        :label="item.view_object_info_text"
                        v-model="item.control_value"
                        @change="val => (sn.saved = false)"
                      />
                    </v-col>
                    <v-col v-if="getSuhlas(sn,item) != null && getSuhlas(sn,item).idStavu > 0" class="pt-4px">
                      <span class="c-grayscale-100 ml-5 " > {{ getSuhlas(sn,item).nazov }} </span>
                    </v-col>
                  </v-row>
                </v-col>  
                <v-col cols="12" class="pa-16px">
                  <v-btn
                    class="btn-primary"
                    v-if="sn.suhlasy.length > 0"
                    @click="poslatNaPodpis(sn)"
                    :loading="sn.suhlasyLoading"
                    :disabled="
                      !getSuhlasyNaPodpis(sn) || sn.suhlasyLoading || !sn.formSuhlasyValid
                    "
                    >Poslať na podpis
                  </v-btn>
                  <span class="negative500 ml-5 mt-8px" v-if="sn.podpisErrorMessage"> {{ sn.podpisErrorMessage }} </span>
                  <span class="negative500 ml-5 mt-8px" v-if="sn.suhlasy.length === 0"> Všetky potrebné súhlasy boli udelené </span>
                </v-col> 
              </v-row>
            </v-form>
            <v-form
              v-if="showSuhlasySensitiveBusiness"
              style="
                border: 1px solid #2c2e34;
                max-width: 100%;
                text-align: left;
                border-radius: 12px;
              "
              class="mt-20px"
              autocomplete="off"
            >
              <v-row no-gutters>
                <v-col cols="12" class="c-grayscale-100 pa-16px pb-0">
                  Pochádza nejaká časť tržieb spoločnosti z podnikateľských aktivít súvisiacich so:

                  <ul class="pt-8px">
                    <li>zbraňami</li>
                    <li>vojenským materiálom</li>
                    <li>hazardnými hrami</li>
                    <li>
                      využitím jadrovej energie
                      <span class="c-negative-600">*</span>
                    </li>
                  </ul>
                </v-col>
                <v-col cols="12" class="pa-16px">
                  <v-radio-group
                    class="sumar-radio-group"
                    v-model="suhlasySensitiveBusinessValue"
                    :disabled="!suhlasySensitiveBusiness || (!suhlasySensitiveBusiness.is_enabled || disableSuhlasySensitiveBusiness)"
                    hide-details
                    @change="setSensitiveBusinessSelection"
                  >
                    <v-radio label="Áno, pochádza" :value="true" class=""></v-radio>
                    <v-radio label="Nie, nepochádza" :value="false" class=""></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" class="pr-16px pl-16px">
                  <v-divider ></v-divider>
                </v-col>
                <v-col cols="12" class="c-grayscale-100 pa-16px">
                  Pred odoslaním na schválenie nahrajte dokument typu <span class="white100">{{suhlasySensitiveBusiness.document_name || 'Dotazník'}}</span> v sekcii Dokumenty.
                </v-col>
              </v-row>
            </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>

    <!-- SUMAR END -->

    <v-card class="card" v-if="pravoNaAdresnuPonuku && (suhlasyNajomcovia[0] || showSuhlasySensitiveBusiness) && (!jeDealer || debug)" >
      <v-col cols="12">
        <h2 class="mr-3">Súhlasy</h2>
        <p class="f16 c-grayscale-100 mb-0px" v-if="formaPodnikania.pkId != 1">Pre odoslanie ponuky na schválenie je potrebné údeliť súhlas s verifikáciou do nebankových registrov.</p>
      </v-col>
      <v-divider></v-divider>
      <v-col cols="12">
        <v-row v-if="suhlasyNajomcovia[0]" no-gutters style="gap: 16px">
            <v-col cols="12" v-for="(item, index) in suhlasyNajomcovia[0].suhlasy"  v-bind:key="index" no-gutters>
              <div class="d-flex" @click.prevent.stop="selectedSuhlas(0,item,item.control_value)" 
                  :style="{
                    cursor: getSuhlasReadonly(getSuhlas(suhlasyNajomcovia[0],item),item) ? 'default' :'pointer',
                    'pointer-events': getSuhlasReadonly(getSuhlas(suhlasyNajomcovia[0],item),item) ? 'none' : 'auto'
                  }">
                <v-checkbox
                  style="white-space: normal; margin-top: 0px; pointer-events: none; "
                  v-bind:class="{
                    dynamic_check_box: true,
                    required: item.is_required,
                    successful: getSuhlasSuccess(suhlasyNajomcovia[0],item)
                  }"
                  class="checkbox-suhlas"
                  :readonly="getSuhlasReadonly(getSuhlas(suhlasyNajomcovia[0],item),item)"
                  :disabled="!item.is_enabled"
                  :rules="item.is_required ? requiredRule : []"
                  :label="item.view_object_info_text"
                  v-model="item.control_value"
                  hide-details
                />
              </div>
            </v-col>
        </v-row>
      </v-col>
      <v-form
        v-if="showSuhlasySensitiveBusiness"
        style="
          border: 1px solid #2c2e34;
          max-width: 100%;
          text-align: left;
          border-radius: 12px;
        "
        autocomplete="off"
      >
        <v-row no-gutters>
          <v-col cols="12" class="c-grayscale-100 pa-16px pb-0">
            Pochádza nejaká časť tržieb spoločnosti z podnikateľských aktivít súvisiacich so:

            <ul class="pt-8px">
              <li>zbraňami</li>
              <li>vojenským materiálom</li>
              <li>hazardnými hrami</li>
              <li>
                využitím jadrovej energie
                <span class="c-negative-600">*</span>
              </li>
            </ul>
          </v-col>
          <v-col cols="12" class="pa-16px">
            <v-radio-group
              v-model="suhlasySensitiveBusinessValue"
              :disabled="!suhlasySensitiveBusiness || !suhlasySensitiveBusiness.is_enabled"
              hide-details
              @change="setSensitiveBusinessSelection"
            >
              <v-radio label="Áno, pochádza" :value="true" class=""></v-radio>
              <v-radio label="Nie, nepochádza" :value="false" class=""></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="12" class="pr-16px pl-16px">
            <v-divider ></v-divider>
          </v-col>
          <v-col cols="12" class="c-grayscale-100 pa-16px">
            Pred odoslaním na schválenie nahrajte dokument typu <span class="white100">{{suhlasySensitiveBusiness.document_name || 'Dotazník'}}</span> v sekcii Dokumenty.
          </v-col>
        </v-row>
      </v-form>
    </v-card>

    <v-card class="card">
      <h2 class="left mr-3">{{ najomca.najomca }}</h2>
      <p class="f16 c-grayscale-100 pt-4px">(Nájomca)</p>

      <v-row class="mt-8 mb-20px">
        <v-col cols="3">
          <v-text-field
            v-model="najomca.typ_najomcu"
            :label="'Typ nájomcu'"
            class="dynamic-input-control sumar-info mb-10px"
            disabled
            hide-details
            outlined
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            :value="najomca.obchodne_meno ? najomca.obchodne_meno : najomca.meno_najomca"
            :label="najomca.obchodne_meno ? 'Obchodné meno' : 'Meno'"
            class="dynamic-input-control sumar-info mb-10px"
            disabled
            hide-details
            outlined
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            :value="najomca.ico ? najomca.ico : najomca.priezvisko_najomca"
            :label="najomca.ico ? 'IČO' : 'Priezvisko'"
            class="dynamic-input-control sumar-info mb-10px"
            disabled
            hide-details
            outlined
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="najomca.zdroj_ponuky"
            :label="'Zdroj ponuky'"
            class="dynamic-input-control sumar-info mb-10px"
            disabled
            hide-details
            outlined
          />
        </v-col>
      </v-row>
    </v-card>
    <v-card class=" card" v-if="jeDealer || najomca.id_zastupcu != -1">
      <h2 class="left mr-3">{{ najomca.meno + ' ' + najomca.priezvisko }}</h2>
      <p class="f16 c-grayscale-100 pt-7px">(Kontaktná osoba)</p>
      <v-row class="mt-10px" no-gutters>
        <v-col cols="3">
          <v-text-field
            v-model="najomca.titul"
            :label="'Titul'"
            class="dynamic-input-control sumar-info"
            disabled
            hide-details
            outlined
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="najomca.pohlavie"
            :label="'Pohlavie'"
            class="dynamic-input-control sumar-info"
            disabled
            hide-details
            outlined
          />
        </v-col>
        <v-col cols="3">
          <v-checkbox
            class="dynamic_check_box sumar-info"
            label="Zahraničná osoba"
            v-model="najomca.zahranicna_osoba"
            disabled
            hide-details
          />
        </v-col>
      </v-row>
      <v-row class="mt-10px" no-gutters>
        <v-col cols="3">
          <v-text-field
            v-model="najomca.meno"
            :label="'Meno'"
            class="dynamic-input-control sumar-info"
            disabled
            hide-details
            outlined
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="najomca.priezvisko"
            :label="'Priezvisko'"
            class="dynamic-input-control sumar-info"
            disabled
            hide-details
            outlined
          />
        </v-col>
        <v-col cols="3" v-if="pravoNaAdresnuPonuku">
          <v-text-field
            :value="najomca.datum_narodenia ? najomca.datum_narodenia.formatDate() : ''"
            :label="'Dátum narodenia'"
            class="dynamic-input-control sumar-info"
            disabled
            hide-details
            outlined
          />
        </v-col>
        <v-col cols="3" v-if="pravoNaAdresnuPonuku">
          <v-text-field
            v-model="najomca.rc"
            :label="najomca.zahranicna_osoba ? 'Identifikačné číslo' : 'Rodné číslo'"
            class="dynamic-input-control sumar-info"
            disabled
            hide-details
            outlined
          />
        </v-col>
        <v-col cols="3" v-if="!pravoNaAdresnuPonuku">
          <v-text-field
            v-model="najomca.statne_obcianstvo"
            :label="'Štátne občianstvo'"
            class="dynamic-input-control sumar-info"
            disabled
            hide-details
            outlined
          />
        </v-col>
      </v-row>
      <v-row class="mt-10px" no-gutters v-if="pravoNaAdresnuPonuku">
        <v-col cols="3">
          <v-text-field
            v-model="najomca.cislo_dokladu"
            :label="najomca.zahranicna_osoba ? 'Číslo dokladu' : 'Číslo OP'"
            class="dynamic-input-control sumar-info"
            disabled
            hide-details
            outlined
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            :value="najomca.datum_vydania ? najomca.datum_vydania.formatDate() : ''"
            :label="najomca.zahranicna_osoba ? 'Dátum od' : 'Dátum vydania'"
            class="dynamic-input-control sumar-info"
            disabled
            hide-details
            outlined
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            :value="najomca.datum_platnosti ? najomca.datum_platnosti.formatDate() : ''"
            :label="najomca.zahranicna_osoba ? 'Dátum do' : 'Dátum platnosti'"
            class="dynamic-input-control sumar-info"
            disabled
            hide-details
            outlined
          />
        </v-col>
      </v-row>
      <v-row class="mt-10px" no-gutters v-if="pravoNaAdresnuPonuku">
        <v-col cols="3">
          <v-text-field
            v-model="najomca.ulica"
            :label="'Ulica, číslo domu'"
            class="dynamic-input-control sumar-info"
            disabled
            hide-details
            outlined
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="najomca.mesto"
            :label="'Mesto'"
            class="dynamic-input-control sumar-info"
            disabled
            hide-details
            outlined
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="najomca.psc"
            :label="'PSČ'"
            class="dynamic-input-control sumar-info"
            disabled
            hide-details
            outlined
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="najomca.statne_obcianstvo"
            :label="'Štátne občianstvo'"
            class="dynamic-input-control sumar-info"
            disabled
            hide-details
            outlined
          />
        </v-col>
      </v-row>
      <v-row class="mt-10px" no-gutters>
        <v-col cols="3">
          <v-text-field
            v-model="najomca.email"
            :label="'Email'"
            class="dynamic-input-control sumar-info"
            disabled
            hide-details
            outlined
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="najomca.mobil"
            :label="'Tel. číslo'"
            class="dynamic-input-control sumar-info"
            disabled
            hide-details
            outlined
          />
        </v-col>
      </v-row>
      <v-row class="mt-10px" no-gutters>
        <v-col cols="3">
          <v-text-field
            :value="najomca.konecny_uzivatel_vyhod ? 'Áno' : 'Nie'"
            :label="'Konečný užívateľ výhod'"
            class="dynamic-input-control sumar-info"
            disabled
            hide-details
            outlined
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            :value="najomca.statutarny_zastupca ? 'Áno' : 'Nie'"
            :label="'Štatutárny zástupca'"
            class="dynamic-input-control sumar-info"
            disabled
            hide-details
            outlined
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="najomca.vztah_k_najomcovi"
            :label="'Funkcia'"
            class="dynamic-input-control sumar-info"
            disabled
            hide-details
            outlined
          />
        </v-col>
      </v-row>
    </v-card>
  </div>    
    <v-dialog v-model="dialog" :content-class="fullSize ? 'w100' : 'pdf-width'" persistent>
      <v-card class="pdf-viewer dialog-card">
        <v-card-title style="display: flex">
          <span>Udelenie súhlasu</span>
          <v-icon style="margin-left: auto" @click="closeSuhlasDialog()">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <v-row class="pdf-component">
            <v-col class="pdf-column" :class="{ 'pdf-column--fullscreen': fullSize }">
              <pdf :src="pdfdata" :page="page" class="pdf" ref="pdf">
                <template slot="loading"> loading content here... </template>
              </pdf>
            </v-col>
          </v-row>

          <v-row class="pdf-navigation">
            <v-col cols="1" style="text-align: center">
              <v-icon @click="page > 1 ? page-- : 1">mdi-chevron-left</v-icon>
            </v-col>
            <v-col class="pages" style="text-align: center">
              Strana {{ page }} z {{ numPages }}
            </v-col>
            <v-col cols="1" style="text-align: center">
              <v-icon @click="page < numPages ? page++ : 1">mdi-chevron-right</v-icon>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions style="display: block" class="px-5 py-4">
          <v-row class="pdf-actions">
            <v-col cols="12" style="display: flex">
              <div class="pa-2 ma-2" @click="fullSize = !fullSize">
                <v-icon style="cursor: pointer">$full_screen</v-icon>
              </div>
              <div class="pa-2 ma-2">
                <a :href="link"  :download="fileName"><v-icon style="cursor: pointer">mdi-download-outline</v-icon> </a>
              </div>
              <div class="pa-2 ma-2" style="cursor: pointer" @click="zoom()">
                <v-icon>mdi-magnify</v-icon>
                <span> {{ scale }} x </span>
              </div>
            </v-col>
          </v-row>
          <v-row class="my-1 card-actions">
            <v-col cols="12" md="auto" class="py-0" style="margin-left: auto">
              <v-btn
                class="btn-secondary"
                density="default"
                variant="elevated"
                @click="setSuhlas(false)"
              >
                Nesúhlasím
              </v-btn>
            </v-col>
            <v-col cols="12" md="auto" class="py-0">
              <v-btn class="btn-primary" variant="elevated" density="default" @click="setSuhlas(true)">
                Oboznámil/a som sa a súhlasím
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <v-dialog
      :value="nespravneParametreDialog"
      overlay-color="#000"
      overlay-opacity="0.66"
      :persistent="true"
      width="500"
    >
      <v-card class="dialog-card">
        <v-card-title class="d-flex justify-space-between">
          <span class="f16"> Nesprávne parametre</span>
          <v-icon style="margin-left: auto" @click="nespravneParametreDialog = false"
            >mdi-close</v-icon
          >
        </v-card-title>
        <v-card-text class="pa-20px">
          <span class="gs100 f16">
            Parametre ponuky nesedia s vybraným dodaváteľom. Je potrebné zaktualizovať ponuku.
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn-secondary" density="default" variant="elevated"> Pomôžeme vám? </v-btn>
          <v-btn class="btn-primary" variant="elevated" density="default"> Zmeniť parametre </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <dokumenty-upload-dialog
      v-model="dokumentUploadDialog"
      :new-id="pripad ? pripad.newId : null"
      :default-typ-dokumentu-id="typDokumentuId"
      @uploaded="handleSensitiveBusinessUploaded"
    />
  </v-container>
</template>
<script>
import TextBox from '../basic/TextBox.vue';
import protectedAxios from '../../auth/axios';
import { mapState, mapGetters, mapMutations } from 'vuex';
import { pripadLinkMixin } from '../../mixins/pripadLinkMixin';
import pdf from 'vue-pdf';
import { eventBus } from '../../main';
import DokumentyUploadDialog from '../dokumentyupload/DokumentyUploadDialog.vue';
export default {
  mixins: [pripadLinkMixin],
  props: {
    menu: Array,
    pravoNaAdresnuPonuku: Boolean,
    formaPodnikania: Object
  },
  components: {
    TextBox,
    pdf,
    DokumentyUploadDialog,
  },
  computed: {
    ...mapState(['pripad']),
    ...mapGetters(['odoslatNaSchvalenieRequest','jeDealer']),
  },
  data: () => ({
    debug: window._env_config.DEBUG,
    najomca: {},
    requiredRule: [value => !!value || 'Súhlas je povinný'],
    suhlasyNajomcovia: [],
    suhlasyState: [],
    suhlasyStateTimer: null,
    suhlasySensitiveBusiness: null,
    suhlasySensitiveBusinessValue: null,
    showSuhlasySensitiveBusiness: false,
    disableSuhlasySensitiveBusiness: false,
    typDokumentuId: null,
    panel: 0,
    dialog: false,
    pdfdata: null,
    urlPdf: '',
    numPages: 0,
    page: 1,
    scale: 1,
    fullSize: false,
    link: null,
    fileName: null,
    suhlas: null,
    osobUdajeExtChanged: false,
    udajeOZmluveExtChanged: false,
    dokumentUploadDialog: false,
    // nespravneParametreDialog: false,
  }),
  methods: {
    ...mapMutations(['openDialog', 'closeDialog', 'setLoadingDialog']),
    async poslatNaPodpis(sn) {
      const suhlasy = sn.suhlasy;
      if (this.$refs['form_suhlasy' + suhlasy[0].id_zastupcu][0].validate()) {
        sn.suhlasyLoading = true;
        let selectedsuhlasy = suhlasy.filter(suhlas => !this.getSuhlasReadonly(this.getSuhlas(sn,suhlas),suhlas));
        let suhlasyReq = selectedsuhlasy.map(suhlas => {
          return {
            typ: suhlas.typ_suhlasu,
            value: suhlas.control_value ? 1 : 0,
          };
        });
        await protectedAxios.post(
          `sumar/suhlasy`,
          {
            newId: this.pripad.newId,
            IdZastupcu: suhlasy[0].id_zastupcu,
            suhlasy: suhlasyReq,
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );

        await protectedAxios
          .post('tlac/generujpdfaposlidodms', {
            NewId: this.pripad.newId,
            CisloPredmetu: 0,
            IdZastupcu: suhlasy[0].id_zastupcu,
            suhlasy: suhlasyReq
          })
          .then(res => {
            //console.log(res);
            sn.podpisErrorMessage = '';
          })
          .catch(e => {
            sn.podpisErrorMessage = 'Chyba pri generovaní dokumentu.';
            //console.log(e, sn.podpisErrorMessage);
            if (e.response.data.error_text) sn.podpisErrorMessage = e.response.data.error_text;
          });
          sn.saved = true;
        this.getSuhlasy().then(() => {
          this.getSuhlasyState();
        });
      }
    },
    startGetSuhlasyStateTask() {
      this.suhlasyStateTimer = setInterval(() => {
        this.getSuhlasy().then(() => {
          this.getSuhlasyState();
        });
      }, 30000);
    },
    getSuhlasyState() {
      for (let i = 0; i < this.suhlasyState.length; i++) {
        this.suhlasyState.splice(0, 1);
      }
      this.suhlasyState.splice(0, 1);
      for (let i = 0; i < this.suhlasyNajomcovia.length; i++) {
        protectedAxios
          .get(
            `sumar/suhlasy/state?newId=${this.pripad.newId}&idZastupcu=${this.suhlasyNajomcovia[i].suhlasy[0].id_zastupcu}`,
            {
              headers: {
                'Content-Type': 'application/json',
              },
            }
          )
          .then(res => {
            if ((res.data.length > 0 || this.formaPodnikania.pkId == 1) && this.suhlasyNajomcovia) {
              let _state = res.data.filter(suhlas => suhlas.idZastupcu == this.suhlasyNajomcovia[i].suhlasy[0].id_zastupcu );
                this.suhlasyNajomcovia[i].state = _state;
                this.suhlasyNajomcovia[i].suhlasyLoading = false;
              this.odoslanieNaSchvalenieCheck();
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
    },
    async getSuhlasySensitiveBusiness() {
      const res = await protectedAxios
        .get(
          `sumar/suhlasy/sensitiveBusiness?newId=${this.pripad.newId}`,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
        .then(res => {
            this.suhlasySensitiveBusiness = res.data;
            this.showSuhlasySensitiveBusiness = res.data.show_sb_otazky == 1;
            this.suhlasySensitiveBusinessValue =
              res.data.is_checked_yes === 1 ? true : res.data.is_checked_no === 1 ? false : null;
        })
        .catch(e => {
          console.error(e);
        });
    },
    setSensitiveBusinessSelection(value) {
      if (!this.suhlasySensitiveBusiness) {
        return;
      }

      this.suhlasySensitiveBusiness.is_checked_yes = value ? 1 : 0;
      this.suhlasySensitiveBusiness.is_checked_no = value ? 0 : 1;
    },
    odoslanieNaSchvalenieCheck() {
      if (this.pripad?.newId != null && this.odoslatNaSchvalenieRequest?.newId === this.pripad?.newId) {
        if (!this.suhlasyNajomcovia.some(n => n.state.id_stavu !== 4 && n.state.id_stavu !== 5)) {
          this.$emit('odoslatNaSchvalenie');
        }
      }
    },
    async handleSensitiveBusinessUploaded() {
      await this.processSuhlasySensitiveBusiness();
    },
    async processSuhlasySensitiveBusiness() {
      if (this.suhlasySensitiveBusinessValue == null) {
        return true;
      }
      if (!this.suhlasySensitiveBusiness.is_enabled) {
        return true;
      }

      try {
        const res = await protectedAxios.post(
          `sumar/processSensitiveBusiness`,
          {
            NewId: this.pripad.newId,
            IsChecked: this.suhlasySensitiveBusinessValue,
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );

        if (!res.data?.success) {
          this.disableSuhlasySensitiveBusiness = true;
          this.typDokumentuId = res.data?.documentTypeId;
          let _dialog = {
            persistent: true,
            header: `<span class="f16"> Odoslať na schválenie</span>`,
            closeIcon: {
              value: true,
            },
            text: `<span class="gs100 f16">
                Pred odoslaním na schválenie nahrajte dokument typu <span class="white100">${res.data?.documentName}</span> v sekcií Dokumenty.
              </span>`,
            textClass: ['pa-20px'],
            primaryBtn: {
              text: 'Prejsť na dokumenty',
              func: () => {
                this.dokumentUploadDialog = true;
                this.closeDialog();
              },
            },
          };

          this.openDialog(_dialog);
          return false;
        }
        else {
          await this.getSuhlasySensitiveBusiness();
        }

        return true;
      } catch (e) {
        return false;
      }
    },
    getSuhlasy() {
      return protectedAxios
        .get(`sumar/suhlasy?newId=${this.pripad.newId}`, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then(res => {
          //console.log(res.data);
          //this.suhlasyNajomcovia = [];
          for (let i = 0; i < res.data.length; i++) {
            const suhlas = res.data[i];
            if (res.data[i] && res.data[i].length) {
              const mappedSuhlas = suhlas.map(suhlas => {
                let value = suhlas.control_value == 1 ? true : false;
                return {
                  control_value: value,
                  control_value_from_db: value,
                  is_enabled: suhlas.is_enabled,
                  is_required: suhlas.is_required,
                  podpisane: suhlas.podpisane,
                  typ_suhlasu: suhlas.typ_suhlasu,
                  view_object_info_text: suhlas.view_object_info_text,
                  meno: suhlas.meno,
                  id_zastupcu: suhlas.id_zastupcu,
                };
              });
              let index = this.suhlasyNajomcovia.findIndex(najomca => najomca.suhlasy[0].id_zastupcu == mappedSuhlas[0].id_zastupcu );
              if (index != -1) {
                if (this.suhlasyNajomcovia[index].saved == true) {
                  this.suhlasyNajomcovia[index].suhlasy = mappedSuhlas;
                }
              } else {
                this.suhlasyNajomcovia.push({
                  suhlasy: mappedSuhlas,
                  state: [],
                  suhlasyLoading: false,
                  podpisErrorMessage: '',
                  saved: false,
                  formSuhlasyValid: true,
                });
              }
            }
          }
          //console.log('GET SUHLASY', this.suhlasyNajomcovia);
        });
    },
    getSuhlas(sn,item) {
      if(sn?.state){
        return sn?.state.find(state => state.typSuhlasu == item.typ_suhlasu);
      }
      return null;
    },
    getSuhlasyNaPodpis(sn){
      for(let i =0; i< sn?.suhlasy.length;i++){
        let suhlas = sn?.suhlasy[i]; 
        if(suhlas.control_value && !this.getSuhlasReadonly(this.getSuhlas(sn,suhlas),suhlas) && (suhlas.typ_suhlasu !== "suhlas_osob_udaje_ext" || (suhlas.typ_suhlasu == "suhlas_osob_udaje_ext" && !suhlas.control_value_from_db)) && (suhlas.typ_suhlasu !== "suhlas_udaje_o_zmluve_ext" || (suhlas.typ_suhlasu == "suhlas_udaje_o_zmluve_ext" && !suhlas.control_value_from_db))){
          return true;
        }
      }
      return false;
    },
    getMenuItemEnabled(name) {
      return !!this.menu.find(m => m.value_member === name)?.is_enabled;
    },
    getMenuItemVisible(name) {
      return !!this.menu.find(m => m.value_member === name)?.is_visible;
    },
    nespravneParametre() {
      let _dialog = {
        persistent: true,
        header: `<span class="f16"> Nesprávne parametre</span>`,
        closeIcon: {
          value: true,
        },
        text: `<span class="gs100 f16">
            Parametre ponuky nesedia s vybraným dodaváteľom. Je potrebné zaktualizovať ponuku.
          </span>`,
        textClass: ['pa-20px'],
        primaryBtn: {
          text: 'Zmeniť parametre',
          func: null,
        },
        secondaryBtn: {
          text: 'Pomôžeme vám?',
          func: null,
        },
      };

      this.openDialog(_dialog);
    },
    async selectedSuhlas(indexNajomcu,_suhlas,val){  
      if(_suhlas.typ_suhlasu == 'suhlas_osob_udaje_ext'){
        _suhlas.control_value = !val;
        this.osobUdajeExtChanged = true;
        return;
      }
      if(_suhlas.typ_suhlasu == 'suhlas_udaje_o_zmluve_ext'){
        _suhlas.control_value = !val;
        this.udajeOZmluveExtChanged = true;
        return;
      }
      if(val == false){
        this.setLoadingDialog({open:true,btext:'Načítavanie súhlasu...',utext:'Proces môže trvať aj niekoľko sekúnd'});
        return await protectedAxios
          .get(`tlac/suhlasNKIMarketing?newId=${this.pripad.newId}&typSuhlasu=${_suhlas.typ_suhlasu}`, {
            headers: {
              'Content-Type': 'application/json',
            },
            responseType: 'blob'
          })
          .then(async res => {    
            const contentType = res.headers['content-type'];

            if (contentType && contentType.includes('application/json')) {
              // Odpoveď obsahuje JSON, čo znamená, že ide o chybu
              // Najprv parsuj Blob na text, potom JSON
              const text = await res.data.text();
              const json = JSON.parse(text);

              if (json.error && json.error > 0) {
                eventBus.$emit('snack-error', `Pri načítaní dokumentu nastala chyba: ${json.message}`);
                return;
              }
            } else {
              this.suhlasyNajomcovia[indexNajomcu].saved = false;
              // Odpoveď je Blob (PDF)
              this.suhlas = {
                typSuhlasu: _suhlas.typ_suhlasu,
                guidDokument: res.headers['guiddokument'],
                IdZastupcu: _suhlas.id_zastupcu,
                indexNajomcu: indexNajomcu
              }
              let blobDocument = new Blob([res.data], {
                type: res.data.type,
              });
              let documentUrl = URL.createObjectURL(blobDocument);
              this.openPdfDialog(documentUrl,_suhlas.typ_suhlasu);
            }
          })
          .catch(e => {
            console.error(e);
          }).
          finally(()=>{
            this.setLoadingDialog();
          });
      }
    },
    openPdfDialog(data,typSuhlasu) {
      let self = this;
      this.dialog = true;
      this.link = data;
      this.fileName = typSuhlasu + "_" + this.pripad.cislo;
      this.pdfdata = pdf.createLoadingTask(data);
      this.pdfdata.promise.then(pdf => {
        self.numPages = pdf.numPages;
      });
    },
    async closeSuhlasDialog(){
      
      this.getSuhlasy().then(async() => {
        return this.getSuhlasyState();
      }).then(() => {
        this.suhlas = null;
        this.dialog = null;
        this.pdfdata = null;
        this.link = null;
        this.fileName = null;
      });
    },
    async setSuhlas(jeSuhlas){
      this.setLoadingDialog({open:true,btext:'Prebieha načítavanie...',utext:'Proces môže trvať aj niekoľko sekúnd'});
      this.dialog = false;
      return await protectedAxios.post(
          `sumar/suhlasDokument`,
          {
            NewId: this.pripad.newId,
            GuidDocument: this.suhlas.guidDokument,
            JeSuhlas: jeSuhlas,
            TypSuhlasu: this.suhlas.typSuhlasu,
            IdZastupcu: this.suhlas.IdZastupcu
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          })
        .then(async res => {
          if(res.data?.error && res.data?.error > 0){
            eventBus.$emit('snack-error', 'Nastala chyba: ' + res.data?.error_text);
            this.dialog = true;
            return;
          }
          this.suhlasyNajomcovia[this.suhlas.indexNajomcu].saved = true;
          return await this.closeSuhlasDialog();
        })
        .catch(e => {
          console.error(e);
          this.dialog = true;
        }).
        finally(()=>{
          this.setLoadingDialog();
        });
    },
    async setSuhlasOsobUdajeExt(){
      let suhlas = this.suhlasyNajomcovia[0].suhlasy.find(suhlas => suhlas.typ_suhlasu == "suhlas_osob_udaje_ext");
      let suhlasReq = 
        {
          typ: suhlas.typ_suhlasu,
          value: suhlas.control_value ? 1 : 0,
        };
      await protectedAxios.post(
          `sumar/suhlas`,
          {
            newId: this.pripad.newId,
            suhlas: suhlasReq,
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        ).finally(()=>{
          this.osobUdajeExtChanged = false;
          this.suhlasyNajomcovia[0].saved = true;
          this.getSuhlasy().then(async() => {
            return this.getSuhlasyState();
          })
        });
    },
    async setSuhlasUdajeOZmluveExt(){
      let suhlas = this.suhlasyNajomcovia[0].suhlasy.find(suhlas => suhlas.typ_suhlasu == "suhlas_udaje_o_zmluve_ext");
      let suhlasReq = 
        {
          typ: suhlas.typ_suhlasu,
          value: suhlas.control_value ? 1 : 0,
        };
      await protectedAxios.post(
          `sumar/suhlas`,
          {
            newId: this.pripad.newId,
            suhlas: suhlasReq,
          },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        ).finally(()=>{
          this.udajeOZmluveExtChanged = false;
          this.suhlasyNajomcovia[0].saved = true;
          this.getSuhlasy().then(async() => {
            return this.getSuhlasyState();
          })
        });
    },
    zoom() {
      let canvas = this.$refs.pdf.$refs.canvas.style;
      switch (this.scale) {
        case 1:
          this.scale = 2;
          break;
        case 2:
          this.scale = 4;
          break;
        default:
          this.scale = 1;
          break;
      }
      canvas.width = this.scale + '00%';
      canvas.height = '100%';
    },
    getSuhlasReadonly(suhlasyNajomcu,item){
      return suhlasyNajomcu?.idStavu === 2 || suhlasyNajomcu?.idStavu === 7 || suhlasyNajomcu?.idStavu === 8 || 
            (item.control_value_from_db && (suhlasyNajomcu?.idStavu === 4 || suhlasyNajomcu?.idStavu === 5 ||  suhlasyNajomcu?.idStavu === 9))
    },
    getSuhlasSuccess(suhlasyNajomcu, item){
      if(item.typ_suhlasu != "suhlas_osob_udaje_ext" && item.typ_suhlasu != 'suhlas_udaje_o_zmluve_ext'){
        return item.control_value_from_db && (this.getSuhlas(suhlasyNajomcu,item) != null &&
              (this.getSuhlas(suhlasyNajomcu,item).idStavu === 4 || this.getSuhlas(suhlasyNajomcu,item).idStavu === 5 ||  this.getSuhlas(suhlasyNajomcu,item).idStavu === 9));
      }else{
        return item.control_value_from_db
      }
    }
  },
  created() {
    protectedAxios
      .get(`sumar/najomca?newId=${this.pripad.newId}`, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then(res => {
        if (res.data.length > 0) {
          this.najomca = res.data[0];
        }
      })
      .catch(e => {
        console.error(e);
      });
    this.getSuhlasy().then(() => {
      this.getSuhlasyState();
      this.startGetSuhlasyStateTask();
      this.getSuhlasySensitiveBusiness();
    });
  },
  beforeDestroy() {
    clearInterval(this.suhlasyStateTimer);
  },
};
</script>
